import { DataCard } from '../../../components/DashboardCard';
import { useVodPurchases } from '../../../hooks/Dashboard/useVodPurchases';

export const VodPurchasesCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { vodPurchases, getVodPurchases, loading } = useVodPurchases();

  return (
    <DataCard
      data={vodPurchases}
      title="VOD Purchases"
      views={['basic']}
      format={[{ id: 'Revenue', value: 'currency' }]}
      orientation="row"
      refresh={true}
      loading={loading}
      onRefresh={getVodPurchases}
      enableTimespan
      theme={theme}
    />
  );
};
